export const AlertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    WARN: 'ALERT_WARN',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
};
